import { OtherVendor } from '../types/otherVendors';

// Type for the Redux state
interface RootState {
  otherVendors: {
    vendors: OtherVendor[];
    selectedVendor: OtherVendor | null;
    loading: boolean;
    creating: boolean;
    updating: boolean;
    deleting: boolean;
    error: string | null;
  };
}

// Basic selectors
export const getOtherVendors = (state: RootState): OtherVendor[] => 
  state.otherVendors.vendors;

export const getSelectedOtherVendor = (state: RootState): OtherVendor | null => 
  state.otherVendors.selectedVendor;

export const getOtherVendorsLoading = (state: RootState): boolean => 
  state.otherVendors.loading;

export const getOtherVendorsCreating = (state: RootState): boolean => 
  state.otherVendors.creating;

export const getOtherVendorsUpdating = (state: RootState): boolean => 
  state.otherVendors.updating;

export const getOtherVendorsDeleting = (state: RootState): boolean => 
  state.otherVendors.deleting;

export const getOtherVendorsError = (state: RootState): string | null => 
  state.otherVendors.error;

// Computed selectors
export const getOtherVendorsCount = (state: RootState): number => 
  state.otherVendors.vendors.length;

export const getOtherVendorById = (state: RootState, vendorId: number): OtherVendor | undefined => 
  state.otherVendors.vendors.find(vendor => vendor.id === vendorId);

export const getOtherVendorsSortedByName = (state: RootState): OtherVendor[] => 
  [...state.otherVendors.vendors].sort((a, b) => a.name.localeCompare(b.name));

export const getOtherVendorsWithImages = (state: RootState): OtherVendor[] => 
  state.otherVendors.vendors.filter(vendor => vendor.vendor_logo);

export const getOtherVendorsWithoutImages = (state: RootState): OtherVendor[] => 
  state.otherVendors.vendors.filter(vendor => !vendor.vendor_logo);

// Loading state selectors
export const isAnyOtherVendorOperationPending = (state: RootState): boolean => 
  state.otherVendors.loading || 
  state.otherVendors.creating || 
  state.otherVendors.updating || 
  state.otherVendors.deleting;

export const getOtherVendorsLoadingStates = (state: RootState) => ({
  loading: state.otherVendors.loading,
  creating: state.otherVendors.creating,
  updating: state.otherVendors.updating,
  deleting: state.otherVendors.deleting,
});

// Search and filter selectors
export const getOtherVendorsBySearchTerm = (state: RootState, searchTerm: string): OtherVendor[] => {
  if (!searchTerm.trim()) return state.otherVendors.vendors;
  
  const term = searchTerm.toLowerCase();
  return state.otherVendors.vendors.filter(vendor =>
    vendor.name.toLowerCase().includes(term) ||
    vendor.description.toLowerCase().includes(term)
  );
};
